import React, { useState, useEffect } from "react";
import { Modal } from "../../../groundworkui-ui";
import axiosClient from "../../../utilities/axios_client";

const ColorPackPickerModal = ({ onColorPackSelect, onClose }) => {
  const [colorPacks, setColorPacks] = useState([]);

  const loadColorPacks = () => {
    axiosClient.get("/color_packs").then((response) => {
      setColorPacks(response.data);
    });
  };

  useEffect(() => {
    loadColorPacks();
  }, []);

  return (
    <Modal onClose={onClose}>
      <div className="flex gap-10 flex-wrap">
        {colorPacks.map((colorPack) => (
          <div
            key={colorPack.id}
            className="flex flex-col items-center border-2 cursor-pointer"
            onClick={() => {
              if (onColorPackSelect) {
                onColorPackSelect(colorPack);
              }
            }}
          >
            <div className="flex">
              <div
                className="h-32 w-32"
                style={{
                  backgroundColor: colorPack.colors["color-primary-500"],
                }}
              ></div>
              <div>
                <div
                  className="h-16 w-16"
                  style={{
                    backgroundColor: colorPack.colors["color-success-500"],
                  }}
                ></div>
                <div
                  className="h-16 w-16"
                  style={{
                    backgroundColor: colorPack.colors["color-info-500"],
                  }}
                ></div>
              </div>
              <div>
                <div
                  className="h-16 w-16"
                  style={{
                    backgroundColor: colorPack.colors["color-warning-500"],
                  }}
                ></div>
                <div
                  className="h-16 w-16"
                  style={{
                    backgroundColor: colorPack.colors["color-danger-500"],
                  }}
                ></div>
              </div>
            </div>
            <div>{colorPack.name}</div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default ColorPackPickerModal;
